import React from 'react';
import { ArrowRight } from 'lucide-react';

export const NotFoundPage = ({ onNavigate }) => {
  return (
    <div className="not-found-page">
      <div className="container" style={{ maxWidth: '560px' }}>
        <div className="not-found-code">404</div>
        <h1 style={{
          fontSize: 'clamp(1.5rem, 3vw, 2rem)',
          fontWeight: 600,
          letterSpacing: '-0.02em',
          marginBottom: '1rem',
          color: 'var(--text-primary)'
        }}>
          Pagina nu există.
        </h1>
        <p style={{
          fontSize: '1.0625rem',
          color: 'var(--text-tertiary)',
          lineHeight: 1.6,
          marginBottom: '2.5rem'
        }}>
          Adresa pe care ai accesat-o nu corespunde niciunei pagini.
          Poate a fost mutată sau ai urmat un link greșit.
        </p>
        <button
          onClick={() => onNavigate('home')}
          className="btn btn-primary"
          style={{ padding: '0.875rem 2rem' }}
        >
          Înapoi acasă
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
